const getPortalLanguage = () => {
  if (typeof window === "undefined") return "en"
  return localStorage.getItem("I18N_LANGUAGE") || "en"
}

const formatDateTime = (dateTimeString, language) => {
  if (!dateTimeString) return "-"
  const date = new Date(dateTimeString)
  if (Number.isNaN(date.getTime())) return "-"

  const lang = language || getPortalLanguage()
  const isArabic = lang === "sa" || lang === "ar"

  if (isArabic) {
    const formatted = new Intl.DateTimeFormat("ar-SA-u-nu-latn", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date)
    // Keep date/time readable in RTL tables (prevents reversed display).
    return `\u200E${formatted}`
  }

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  let hours = date.getHours()
  const meridiem = hours >= 12 ? "PM" : "AM"
  hours = hours % 12 || 12
  const minutes = String(date.getMinutes()).padStart(2, "0")

  return `${year}-${month}-${day} ${String(hours).padStart(2, "0")}:${minutes} ${meridiem}`
}

export default formatDateTime
